import { createSelector } from 'reselect';
import { biSignInUpAccountCopyUpdateSelector } from 'selectors/testTarget/offers/biSignInUpAccountCopyUpdate/biSignInUpAccountCopyUpdateSelector';

const experienceSelector = createSelector(biSignInUpAccountCopyUpdateSelector, biSignInUpAccountCopyUpdate => biSignInUpAccountCopyUpdate.experience);

export { experienceSelector };
